import { useEffect } from 'react';
import { useUnit } from 'effector-react';
import mapboxgl from 'mapbox-gl';
import { center } from '@turf/turf';
import ReactDOM from 'react-dom/client';
import { $mapLoaded } from '../../../models/mapModel/index.js';
import {
  $minresPolygons,
  changePopupDataEv,
} from '../../../models/investProModel/index.js';
import { changeLayerVisibility, flyTo } from '../../../utils/mapbox-utils.js';
import { $activeProjects } from '../../../models/activeFiltersModel/index.js';
import DotPopup from '../../MapPopups/DotPopup/DotPopup.jsx';

const onClick = (e) => {
  const feature = e.features[0];
  const poly_center = center(feature);
  const { coordinates } = poly_center.geometry;
  changePopupDataEv(feature);

  // if (window.dotPopups && window.dotPopups.length > 0) {
  //   if (
  //     window.dotPopups.find((item) => item.options.id === feature.properties.id)
  //   )
  //     return;
  // }
  //
  // const newPopup = new mapboxgl.Popup({
  //   closeOnClick: false,
  //   closeButton: false,
  //   id: feature.properties.id,
  // })
  //   .setLngLat(coordinates)
  //   .setHTML('')
  //   .addTo(window.map);
  //
  // if (!window.dotPopups) {
  //   window.dotPopups = [newPopup];
  // } else {
  //   if (window.dotPopups.length === 1) {
  //     const first = window.dotPopups.shift();
  //     first.remove();
  //   }
  //   window.dotPopups.push(newPopup);
  // }
  //
  // const popups = Array.from(
  //   document.getElementsByClassName('mapboxgl-popup-content')
  // );
  // popups.forEach((popup) => {
  //   if (popup.childNodes.length === 0)
  //     ReactDOM.createRoot(popup).render(
  //       <DotPopup feature={feature} instance={newPopup} />
  //     );
  // });
};

function MinresLayer() {
  const mapLoaded = useUnit($mapLoaded);
  const polygons = useUnit($minresPolygons);
  const activeProjects = useUnit($activeProjects);

  const createLayer = (update) => {
    const investProAdminData = {
      type: 'FeatureCollection',
      features: polygons,
    };

    if (update) {
      window.map
        .getSource('invest_pro_minres_source')
        .setData(investProAdminData);
    } else {
      if (!window.map.getSource('invest_pro_minres_source')) {
        window.map.addSource('invest_pro_minres_source', {
          type: 'geojson',
          data: investProAdminData,
        });
      }

      if (!window.map.getLayer('invest_pro_minres_layer')) {
        window.map.addLayer({
          id: 'invest_pro_minres_layer',
          type: 'fill',
          source: 'invest_pro_minres_source',
          paint: {
            'fill-color': '#4682B4',
            'fill-outline-color': '#000000',
          },
        });

        window.map.on('click', 'invest_pro_minres_layer', onClick);

        window.map.on('mouseenter', 'invest_pro_minres_layer', () => {
          window.map.getCanvas().style.cursor = 'pointer';
        });

        window.map.on('mouseleave', 'invest_pro_minres_layer', () => {
          window.map.getCanvas().style.cursor = '';
        });

        changeLayerVisibility('invest_pro_minres_layer', false);
      }
    }
  };

  useEffect(() => {
    if (mapLoaded && polygons) {
      if (window.map.getLayer('invest_pro_minres_layer')) {
        createLayer(true);
      } else {
        setTimeout(() => {
          createLayer(false);
        }, 500);
      }
    }
  }, [mapLoaded, polygons]);

  useEffect(() => {
    if (mapLoaded && window.map.getLayer('invest_pro_minres_layer')) {
      if (activeProjects.includes('minres')) {
        changeLayerVisibility('invest_pro_minres_layer', true);
      } else {
        changeLayerVisibility('invest_pro_minres_layer', false);
      }
    }
  }, [activeProjects]);

  return null;
}

export default MinresLayer;
